import React from 'react';
import cn from 'classnames';
import { ICardDetailsWrapperConnectedProps } from './view.connect';
import s from './styles.scss';

export const CardDetailsWrapper: React.FC<React.PropsWithChildren<ICardDetailsWrapperConnectedProps>> = (props) => (
  <div
    className={cn(s.cardDetailsWrapper, {
      [s.mobile]: props.mobile,
      [s.desktop]: !props.mobile,
    })}
  >
    {props.children}
  </div>
);
CardDetailsWrapper.displayName = 'CardDetailsWrapper';
